/**
 * Reine Zustands-Ableitung für die Kanzlei-Kacheln (FiBu/LoBu) auf dem
 * Dashboard (BL-347, 16.09.2026).
 *
 * Fund (externes Anwendungsreview, 16.09.2026): beide Kacheln zeigten
 * "Noch kein Monat importiert" bei tatsächlich sechs (FiBu) bzw. acht (LoBu)
 * importierten Monaten. Backend-seitig ist die Berechnung korrekt und durch
 * `susa-jahres-master.test.ts` gedeckt — der Fehler lag darin, dass
 * `isLoading`/`isError` nicht von einem echten Leerzustand unterschieden
 * wurden: eine noch laufende oder fehlgeschlagene Abfrage sah exakt so aus
 * wie "die Kanzlei hat noch nie etwas geliefert".
 */
export type KanzleiTileState = 'locked' | 'loading' | 'error' | 'empty' | 'data';

export function pickKanzleiTileState(params: {
  canWrite: boolean;
  isLoading: boolean;
  isError: boolean;
  hasSummary: boolean;
}): KanzleiTileState {
  if (!params.canWrite) return 'locked';
  if (params.isLoading) return 'loading';
  if (params.isError) return 'error';
  if (!params.hasSummary) return 'empty';
  return 'data';
}
